var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutsideSitePerimeters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2485 0H9.00444C8.59182 0 8.25291 0.338912 8.25291 0.751534C8.25291 1.16415 8.59182 1.50307 9.00444 1.50307L11.4212 1.50317L4.39193 8.5472C4.09722 8.84191 4.09722 9.31353 4.39193 9.60823C4.53933 9.75564 4.73084 9.82923 4.92244 9.82923C5.11404 9.82923 5.30556 9.75553 5.45295 9.60823L12.497 2.57893V4.99571C12.497 5.40833 12.8359 5.74725 13.2485 5.74725C13.6611 5.74725 14.0001 5.40833 14.0001 4.99571L14.0002 0.75161C14.0002 0.338989 13.6612 7.64677e-05 13.2486 7.64677e-05L13.2485 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3029 6.97036C10.8903 6.97036 10.5513 7.30927 10.5513 7.72189V10.7429C10.5513 11.7155 9.75562 12.4965 8.79767 12.4965H3.2715C2.29886 12.4965 1.51783 11.7008 1.51783 10.7429V5.21669C1.51783 4.24406 2.31355 3.46303 3.2715 3.46303H6.29247C6.70509 3.46303 7.04401 3.12412 7.04401 2.71149C7.04401 2.29887 6.70509 1.95996 6.29247 1.95996H3.2715C1.47365 1.95996 0 3.4189 0 5.23146V10.7576C0 12.5555 1.45894 14.0291 3.2715 14.0291H8.79767C10.5955 14.0291 12.0692 12.5702 12.0692 10.7576V7.72192C12.0544 7.3093 11.7155 6.97031 11.3028 6.97031L11.3029 6.97036Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutsideSitePerimeters);
export default __webpack_public_path__ + "static/media/OutsideSitePerimeters.85d1e311acb6e1616dc0688439c36f5a.svg";
export { ForwardRef as ReactComponent };